import { Palette } from "@mui/material/styles";
import { Layout } from "plotly.js";

export const CONSUMPTION_IMPACT_HOVER_TEMPLATE =
  "%{y} (%{customdata[0]} created, %{customdata[1]} modified, %{customdata[2]} deleted)<extra></extra>";

type PlotLayoutArgs = Readonly<{
  palette: Palette;
  falseNegativesLabel: string;
  falsePositivesLabel: string;
}>;

export const buildConsumptionImpactLayout = ({
  palette,
  falseNegativesLabel,
  falsePositivesLabel,
}: PlotLayoutArgs): Partial<Layout> => ({
  autosize: true,
  grid: { rows: 2, columns: 1, pattern: "independent" },
  xaxis: {
    type: "date",
    anchor: "y",
    showticklabels: false,
  },
  xaxis2: {
    type: "date",
    anchor: "y2",
    matches: "x",
  },
  yaxis: {
    title: { text: falseNegativesLabel },
    domain: [0.55, 1],
    rangemode: "tozero",
    zeroline: true,
    zerolinewidth: 2,
    zerolinecolor: palette.text.primary,
  },
  yaxis2: {
    title: { text: falsePositivesLabel },
    domain: [0, 0.45],
    rangemode: "tozero",
    zeroline: true,
    zerolinewidth: 2,
    zerolinecolor: palette.text.primary,
  },
  shapes: [
    {
      type: "rect",
      xref: "paper",
      yref: "paper",
      x0: 0,
      x1: 1,
      y0: 0.55,
      y1: 1,
      fillcolor: palette.data.red,
      opacity: 0.06,
      line: { width: 0 },
      layer: "below",
    },
    {
      type: "rect",
      xref: "paper",
      yref: "paper",
      x0: 0,
      x1: 1,
      y0: 0,
      y1: 0.45,
      fillcolor: palette.data.orange,
      opacity: 0.06,
      line: { width: 0 },
      layer: "below",
    },
  ],
  margin: { l: 60, r: 30, t: 30, b: 60 },
  hovermode: "x unified",
  plot_bgcolor: "transparent",
  paper_bgcolor: "transparent",
  legend: { orientation: "h", y: -0.2 },
});
